var n=function(n){return n},o=["container","control","valueContainer"],r="dropdown-menu-id";export{o as ADD_AUTO_HEIGHT_COMPONENTS,r as DROPDOWN_ID,n as defaultCustomStyles};
